import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { useT } from "@/lib/i18n";

const endsAt = (d) => new Date(`${d}T23:59:59+07:00`).getTime();
const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ end, testid }) => {
  const t = useT();
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const i = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(i); }, []);
  const left = Math.max(0, endsAt(end) - now);
  if (!left) return null;
  const s = Math.floor(left / 1000);
  const d = Math.floor(s / 86400);
  const hms = `${pad(Math.floor((s % 86400) / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full bg-[#DC2626] px-2.5 py-1 font-mono-x text-xs font-bold text-white shadow">
      <Timer className="h-3.5 w-3.5" /> {t("Berakhir dalam")} {d > 0 ? `${d}${t("h")} ` : ""}{hms}
    </span>
  );
};
